module.exports = __webpack_public_path__ + "img/20200226135131303.affedd49.jpg";